import React, { useContext } from "react";
import { useNavigate } from "react-router";
import AuthManager from "../Common/AuthManager";
import Utils from "../Common/Utils";
import Logger from "../Common/Logger";
import { AppContext } from "../Context/AppContext";

function Logout(props) {
  const navigate = useNavigate();
  const appData = useContext(AppContext);

  const handle_logout = async () => {
    Logger.log("Success", "Signout", "Signed Out of GMS frontend App.", "0");
    appData.setSelectedIndustry(null);
    appData.setChannelKey("");
    appData.setChannelName("");
    AuthManager.logoutUser();
    await Utils.sleep(5000);
    navigate("/login", { replace: true });
  };
  React.useEffect(() => {
    Utils.SetWindowTitle("Logout");
    handle_logout();
  });
  return (
    <React.Fragment>
      <div className="container col-6 h-100 justify-content-center align-items-center">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="row">
          <div className="bg-white alert alert-primary">
            <span className="spinner-border spinner-border-sm"></span>&nbsp;
            <strong>Info!</strong> Please wait while we take you back to the
            login page
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Logout;
